/**
 * 将 localStorage / authManager 中的登录态同步到 App 根组件（顶栏用户名等）
 */
let appVm = null

export function registerAppAuth(vm) {
  appVm = vm
}

export function syncAppLogin(logindata) {
  if (appVm && typeof appVm.login === 'function') {
    appVm.login(logindata)
    return true
  }
  return false
}

/** 从 localStorage 恢复顶栏登录态（token 已写入但 App 未刷新时） */
export function syncAppSessionFromStorage() {
  if (appVm && typeof appVm.refreshAuthFromStorage === 'function') {
    appVm.refreshAuthFromStorage()
    return true
  }
  return false
}
